<div class="client-profile-create__wrapper">
  <button
    type="button"
    class="lum-button"
    [ngClass]="{
      'lum-button--secondary': mode === 'Create',
      'lum-button--link': mode !== 'Create',
    }"
    (click)="onOpenDialog()"
  >
    <lum-ui-icon
      [icon]="mode === 'Create' ? 'add-1' : 'edit'"
      [width]="mode === 'Create' ? 13 : 17"
      [height]="mode === 'Create' ? 13 : 17"
      [style]="mode === 'Create' ? 'padding-top:2px;padding-bottom:2px' : ''"
    ></lum-ui-icon>
    {{ mode === 'Create' ? 'Create New Company' : 'Edit Company' }}
  </button>
</div>
